'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Lock = require('components/common/behaviors/lock');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');

var ConfigurationView = AbstractTableView.extend({
    controller: undefined,

    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click div.js-tab-btn-define_value': 'defineValue',
            'click div.js-tab-btn-select_values': 'selectValues',
            'click div.js-clone': 'cloneValue',
            'click div.js-tab-btn-init_schema': 'initializeSchema',
            'click div.js-tab-btn-init_meter_values': 'initializeMeterValues',
            'click a.js-configure-value': 'configureValue',
        });
    },

    behaviors: {
        lock: {
            behaviorClass: Lock,
            buttons: [
                '#js-init_schema',
                '#js-init_meter_values',
                '#js-select_values',
                '#js-define_value',
                '#js-delete',
                '#js-clone',
                '#js-action',
                '.js-configure-value',
            ],

            getDeviceID: function (view) {
                return view.device.id;
            },
        },
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.device = options.device;
        this.permissions = options.permissions;
        this.smartTemp = options.smartTempInfo;

        var tableOptions = {
            title: i18n.TR('Wertekonfiguration'),
            columns: [
                { id: '#_name', name: 'Name', alwaysVisible: true }, // name: i18n.TR('Name')
                { id: '#_type', name: 'Type' }, // name: i18n.TR('Type')
                { id: '#_nr', name: 'Nummer', isNumeric: true }, // name: i18n.TR('Nummer')
                { id: '#_length', name: 'Länge', isNumeric: true }, // name: i18n.TR('Länge')
            ],
            hasRefreshButton: true,
            hasSelectionButtons: true,
            selectionButtons: [
                { ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' },
                { ButtonText: i18n.TR('Duplizieren'), ButtonID: 'clone', ButtonIcon: 'fa fa-copy' },
            ],
            customButtons: [{ ButtonIcon: 'fa fa-plus', ButtonID: 'define_value' }],
            headingID: 'valuesConfig',
        };

        options.collection.cleanNonModbusData();

        if (this.device.get('category') != Consts.CategoryData.Virtual.category) {
            tableOptions.columns.push({ id: '#_update_class', name: 'Aktualisierung' }); // name: i18n.TR('Aktualisierung')
        }

        // append device specific custom buttons
        // TODO: generalize -- move to device specific controller
        var category = this.device.get('category');
        if (category !== Consts.Category.GenericModbus) {
            tableOptions.customButtons.unshift({
                ButtonText: i18n.TR('Werte auswählen'),
                ButtonID: 'select_values',
                ButtonIcon: 'glyphicon glyphicon-cloud-upload',
            });
        }
        if (category === Consts.Category.Controller) {
            tableOptions.customButtons.unshift({
                ButtonText: i18n.TR('Anlage initialisieren'),
                ButtonID: 'init_schema',
            });
        }
        if (category === Consts.Category.Meter) {
            tableOptions.customButtons.unshift({
                ButtonText: i18n.TR('Zählerwerte initialisieren'),
                ButtonID: 'init_meter_values',
            });
        }

        if (this.smartTemp) {
            tableOptions.warnings = this.smartTemp.getWarnings(
                i18n.TR('Für Smart Temp benötigte Werte können nicht editiert werden, solange Smart Temp aktiv ist.')
            );
        }
        AbstractTableView.prototype.initialize.apply(this, [tableOptions]);
    },

    setPermission: function (permissions) {
        if (permissions.get(Consts.Permissions.AdminConfig) || AppState.isRestricted()) {
            this.initializeReadOnly();
        }
    },

    showDeviceSettings: function () {
        this.controller.showSettingsDialog(
            this.device,
            function () {} // do nothing
        );
    },

    defineValue: function (e) {
        this.controller.showConfigureValueDialog({
            deviceID: this.device.id,
            deviceCategory: this.device.get('category'),

            update_cb: function () {
                // force reload: update collection
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
        });
    },

    updateSelectionButtons: function () {
        // overwrite default behaviour

        // .. nothing selected? -> disable buttons
        if (this.collection.selectedLength == 0) {
            this.ui.btnsSelection.addClass('disabled');
            return;
        }

        // register selected, that is protected for smart temp?
        var self = this;
        var selectedProtected =
            _.find(this.collection.selected, function (val) {
                return self.smartTemp.getProtectedValues(true).includes(val.getAddress());
            }) !== undefined;

        // .. exactly one item selected? -> enable all buttons
        if (this.collection.selectedLength == 1 && !selectedProtected) {
            this.ui.btnsSelection.removeClass('disabled');
            return;
        }

        // .. all other cases -> enable deletion, disable cloning
        $('#js-delete').removeClass('disabled');
        $('#js-clone').addClass('disabled');

        if (selectedProtected) {
            $('#js-delete').addClass('disabled');
        }
    },

    cloneValue: function (e) {
        // get selected model
        var selectedModel = _.find(this.collection.models, function (m) {
            return m.selected == true;
        });

        var type = selectedModel.get('type');
        var length = selectedModel.get('length');

        if (!type.startsWith('MB') || length > 4) {
            Notification.show(
                'info',
                i18n.TR('Information'),
                i18n.TR('Nur Modbus-Datenpunkte können dupliziert werden.')
            );
            return;
        }

        this.controller.showConfigureValueDialog({
            deviceID: this.device.id,
            deviceCategory: this.device.get('category'),
            clone: selectedModel.attributes,

            update_cb: function () {
                // force reload: update collection
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
        });
    },

    selectValues: function (e) {
        this.controller.showSelectValuesDialog({
            deviceID: this.device.id,
            group: this.device.getGroupFilter(),
            values: this.collection,
            AllowedValueTypes: ['MBR', 'MBC'],
            showUpdateClassInfo: true,
            showUpdateClassDropdown: true,
            useCustomValues: true,

            update_cb: function (changes) {
                // TODO: The selected values are updated sequentially. Provide
                //       dedicated REST endpoint for bulk-update.
                var deferreds = [];

                // 1. delete elements
                for (var i = 0; i < changes.deleted.length; ++i) {
                    deferreds.push(changes.deleted[i].destroy());
                }
                // 2. add new elements
                for (var i = 0; i < changes.added.length; ++i) {
                    deferreds.push(changes.added[i].save());
                }
                // 3. put changed elements
                for (var i = 0; i < changes.changed.length; ++i) {
                    deferreds.push(changes.changed[i].save());
                }
                // 4. Synchronize and update UI
                $.when
                    .apply($, deferreds)
                    .done(function () {
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    })
                    .fail(function () {
                        Backbone.history.loadUrl(Backbone.history.fragment);
                        Notification.show(
                            'error',
                            i18n.TR('Fehler'),
                            i18n.TR('Wertauswahl konnte nicht aktualisiert werden.')
                        );
                    });
            },
        });
    },

    configureValue: function (e) {
        e.preventDefault();

        // deny editing for read-only-permission
        if (this.permissions.attributes[Consts.Permissions.AdminConfig]) {
            Notification.show(
                'error',
                i18n.TR('Fehler'),
                i18n.TR('Sie haben keine Berechtigung für das Editieren der Wertekonfiguration.')
            );
            return;
        }

        var model = this.collection.get(e.currentTarget.id);

        // deny editing of calculated values
        if (model.get('type') == 'SCR') {
            Notification.show(
                'info',
                i18n.TR('Berechneter Wert'),
                i18n.TR('Berechnete Werte können nicht editiert werden.')
            );
            return;
        }

        this.controller.showConfigureValueDialog({
            deviceID: this.device.id,
            deviceCategory: this.device.get('category'),
            model: model,
            smartTempInfo: this.smartTemp,

            update_cb: function () {
                // force reload: update collection
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
        });
    },

    initializeSchema: function (e) {
        var self = this;

        Utils.showConfirmationDialog({
            title: i18n.TR('Anlage initialisieren'),
            hint:
                '<div class="alert alert-danger">' +
                i18n.TR('Die aktuelle Konfiguration wird überschrieben.') +
                '</div>' +
                i18n.TR('Die Anlage wird neu initialisiert.') +
                ' ' +
                i18n.TR('Sind Sie sicher?'),
            action_label: i18n.TR('Initialisieren'),

            action_cb: function () {
                self.controller.reInitializeDevice({
                    id: self.device.id,
                    schema_init: true,
                    update_cb: function () {
                        // force reload: update collection
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    },
                });
            },
        });
    },

    initializeMeterValues: function (e) {
        var self = this;

        Utils.showConfirmationDialog({
            title: i18n.TR('Zählerwerte initialisieren'),
            hint:
                '<div class="alert alert-danger">' +
                i18n.TR('Die aktuelle Konfiguration wird überschrieben.') +
                '</div>' +
                i18n.TR('Die verfügbaren Zählerwerte werden neu initialisiert.') +
                ' ' +
                i18n.TR('Sind Sie sicher?'),
            action_label: i18n.TR('Initialisieren'),

            action_cb: function () {
                self.controller.reInitializeDevice({
                    id: self.device.id,
                    schema_init: true,
                    update_cb: function () {
                        // force reload: update collection
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    },
                });
            },
        });
    },
});

module.exports = ConfigurationView;
